import { render } from "./PostProcessingView.vue?vue&type=template&id=72b562e6"
import script from "./PostProcessingView.vue?vue&type=script&lang=js"
export * from "./PostProcessingView.vue?vue&type=script&lang=js"
script.render = render

export default script